export function navigateToSection(navigate, pathname, sectionId) {
  if (pathname === '/') {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    return;
  }

  navigate('/', { state: { scrollTo: sectionId } });
}
